import { render, staticRenderFns } from "./FormIncident.vue?vue&type=template&id=63e7bb54&"
import script from "./FormIncident.vue?vue&type=script&lang=js&"
export * from "./FormIncident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63e7bb54')) {
      api.createRecord('63e7bb54', component.options)
    } else {
      api.reload('63e7bb54', component.options)
    }
    module.hot.accept("./FormIncident.vue?vue&type=template&id=63e7bb54&", function () {
      api.rerender('63e7bb54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/incident/handling/FormIncident.vue"
export default component.exports